// extracted by mini-css-extract-plugin
export default {"asset-details-rule":"P-XOL03oG3lklxdvysKSJa3GzDg-5-mVQH0ukzVMvhI="};